import i18next, { TFunction } from 'i18next';
export const getLanguage = (): string => i18next.language || window.localStorage.lng;
export const setLanguage = (lng: string): Promise<TFunction> => i18next.changeLanguage(lng);
